"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOCALE = exports.LOCALE_HEADER = exports.ResponseType = exports.SupportedMediaType = void 0;
var SupportedMediaType;
(function (SupportedMediaType) {
    SupportedMediaType["APPLICATION_JSON"] = "application/json";
    SupportedMediaType["JSON_LINES_MIMETYPE_FOR_STREAM"] = "application/x-ndjson";
    SupportedMediaType["CSV"] = "text/csv";
})(SupportedMediaType || (exports.SupportedMediaType = SupportedMediaType = {}));
var ResponseType;
(function (ResponseType) {
    ResponseType["JSON"] = "json";
    ResponseType["CSV"] = "csv";
})(ResponseType || (exports.ResponseType = ResponseType = {}));
exports.LOCALE_HEADER = 'idf-locale';
var LOCALE;
(function (LOCALE) {
    LOCALE["en_CA"] = "en-CA";
    LOCALE["en_US"] = "en-US";
    LOCALE["fr_CA"] = "fr-CA";
    LOCALE["fr_FR"] = "fr-FR";
})(LOCALE || (exports.LOCALE = LOCALE = {}));
